<span mat-menu-item *ngFor="let option of options; let i = index; trackBy: trackByValFn">
  <mat-checkbox
    class="w-100 d-flex"
    [value]="option.value"
    [checked]="checkedList?.includes(option.value) || indeterminateState[option.value] === checkboxState.exclude"
    [indeterminate]="indeterminateState[option.value] === checkboxState.exclude"
    (change)="onFilterChanged($event)"
  >
    <span
      [smTooltip]="option.tooltip || option.label"
      smShowTooltipIfEllipsis
      [showAllwaysTooltip]="!!option.tooltip"
      matTooltipPosition="left"
      data-id="FilterOption"
      class="ellipsis label"
    >{{option.label}}</span>
  </mat-checkbox>
</span>
<div *ngIf="options?.length === 0" class="empty-menu flex-middle">No item found</div>
<div *ngIf="options === null" class="flex-middle">
  <mat-spinner [diameter]="80" [strokeWidth]="8"></mat-spinner>
</div>
